// How much of a chapter a member must have demonstrated before they can go on that
// chapter's pre-filled VIERA evaluation summary (#1698).
//
// The summary is the artifact a department prints, signs and emails to VIERA. The bar
// used to be 100% of the chapter's practical drills, on both the client and the api — the
// rule #1014 introduced so a part-evaluated member couldn't print as a half-blank row
// that reads as a failure.
//
// VIERA accepts a chapter submitted at 60% of its JPRs, so that's the bar. A member below
// it can't go on the form at all; a member above it may, at the officer's discretion —
// which member goes on which batch is the picker's job, not this rule's.
//
// This module is the single definition of it. The client uses it to decide who the picker
// will let an officer tick; the api uses it to narrow whatever uids the client sent, and
// is the authority. They MUST agree — a client that offers a member the api then drops
// produces a form quietly missing a name.
const EVALUATION_FORM_THRESHOLD = 60;

// The fewest signed-off drills that meets the threshold. Rounded UP: the threshold is a
// minimum ("at least 60%"), so 60% of a 4-drill chapter is 3 drills, not 2.4 rounded down
// to 2 — which would be 50% and short of what VIERA was told.
const drillsNeededForEvaluationForm = total => {
    if (!total) return 0;
    return Math.ceil((total * EVALUATION_FORM_THRESHOLD) / 100);
};

// Does this member's practical progress through the chapter clear the bar? Compared as
// integers (done · 100 ≥ threshold · total) so no rounding sits between the two sides.
//
// A chapter with no drills is never submittable — there is nothing to have demonstrated,
// and a vacuous pass would print an empty grid.
const meetsEvaluationFormThreshold = (done, total) => {
    if (!total) return false;
    return done * 100 >= EVALUATION_FORM_THRESHOLD * total;
};

module.exports = {
    EVALUATION_FORM_THRESHOLD,
    drillsNeededForEvaluationForm,
    meetsEvaluationFormThreshold
};
